// graphql_high_score.ts
import { gql, ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';
import { Query, QueryGetHighScoreVideosArgs, ScoredVideosResult, Video } from '../types/generated/graphql';

export const GET_HIGH_SCORE_VIDEOS = gql`
  query GetHighScoreVideos($id: ID!, $limit: Int) {
    getHighScoreVideos(id: $id, limit: $limit) {
      videos {
        id
        title
        description
        duration
        view_count
        published
        is_live
        is_watched
        thumbnails {
          url
          width
          height
        }
        author {
          id
          name
          thumbnails {
            url
            width
            height
          }
        }
      }
      scores {
        videoId
        score
        rating
        restricted
        explanation
        restrictingAgents {
          specialization
          version
        }
      }
    }
  }
`;

export function useGetHighScoreVideos(
  client: ApolloClient<NormalizedCacheObject>,
  id: string,
  limit: number = 10
) {
  type T = Pick<Query, 'getHighScoreVideos'>;
  type I = QueryGetHighScoreVideosArgs;

  return useQuery<T, I>(GET_HIGH_SCORE_VIDEOS, {
      variables: { id, limit },
      client
    });
}